/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Plot from "react-plotly.js"; // Import Plot from react-plotly.js
import instance from "apiHandler/api-base";
import { useUserData } from "components/customHooks/userDataContext";

function Dashboard(props) {
  var pdone_data_dict = { code: 1 };
  var pdtwo_data_dict = { code: 2 };
  const userData = useUserData();
  const token = userData?.access_token;

  const [isSending, setIsSending] = useState(false);
  const sendRequest = (event) => {
    setIsSending(!isSending);
  };

  const [selectedOne, setSelectedOne] = React.useState("");
  const changeSelectOptionHandlerOne = (event) => {
    setSelectedOne(event.target.value);
  };

  const [selectedTwo, setSelectedTwo] = React.useState("");
  const changeSelectOptionHandlerTwo = (event) => {
    setSelectedTwo(event.target.value);
  };

  if (selectedOne === "1") {
    pdone_data_dict = { code: 1 };
  } else if (selectedOne === "2") {
    pdone_data_dict = { code: 2 };
  } else if (selectedOne === "3") {
    pdone_data_dict = { code: 3 };
  } else if (selectedOne === "4") {
    pdone_data_dict = { code: 4 };
  } else if (selectedOne === "5") {
    pdone_data_dict = { code: 5 };
  } else if (selectedOne === "6") {
    pdone_data_dict = { code: 6 };
  } else if (selectedOne === "7") {
    pdone_data_dict = { code: 7 };
  } else if (selectedOne === "8") {
    pdone_data_dict = { code: 8 };
  }

  if (selectedTwo === "1") {
    pdtwo_data_dict = { code: 1 };
  } else if (selectedTwo === "2") {
    pdtwo_data_dict = { code: 2 };
  } else if (selectedTwo === "3") {
    pdtwo_data_dict = { code: 3 };
  } else if (selectedTwo === "4") {
    pdtwo_data_dict = { code: 4 };
  } else if (selectedTwo === "5") {
    pdtwo_data_dict = { code: 5 };
  } else if (selectedTwo === "6") {
    pdtwo_data_dict = { code: 6 };
  } else if (selectedTwo === "7") {
    pdtwo_data_dict = { code: 7 };
  } else if (selectedTwo === "8") {
    pdtwo_data_dict = { code: 8 };
  }

  const [pdone, setPdone] = useState({});
  const [pdtwo, setPdtwo] = useState({});

  // Using useEffect to call the API once mounted and set the data
  useEffect(() => {
    (async () => {
      const result = await instance({
        method: "post",
        url: "/getPlot",
        data: pdone_data_dict,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setPdone(result.data);

      const resultTwo = await instance({
        method: "post",
        url: "/getPlot",
        data: pdtwo_data_dict,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      setPdtwo(resultTwo.data);

      setIsSending(false);
    })();
  }, [isSending]);

  return (
    <div className="reports-page">
      <div className="reports-input">
        <select
          id="plotone"
          onChange={changeSelectOptionHandlerOne}
          className="form-control"
        >
          <option value="1">
            Agent Wise Dictation Completion Time Distribution
          </option>
          <option value="2">Medical Recommendation Status Trend</option>
          <option value="3">
            Dictations Assignment Status And Agent Wise Allocations
          </option>
          <option value="4">Dictations Creation And Completion Trend</option>
          <option value="5">
            Color Coded Dictations Status Agent Wise View Table
          </option>
          <option value="6">
            Agent Wise Dictation Status Distribution Pie Chart
          </option>
          <option value="7">Agent Dictations Status Month Wise Trend</option>
          <option value="8">
            Agent Wise Dictations Completion Progress Gauge
          </option>
        </select>
        <select
          id="plottwo"
          onChange={changeSelectOptionHandlerTwo}
          className="form-control"
        >
          <option value="2">Medical Recommendation Status Trend</option>
          <option value="1">
            Agent Wise Dictation Completion Time Distribution
          </option>
          <option value="3">
            Dictations Assignment Status And Agent Wise Allocations
          </option>
          <option value="4">Dictations Creation And Completion Trend</option>
          <option value="5">
            Color Coded Dictations Status Agent Wise View Table
          </option>
          <option value="6">
            Agent Wise Dictation Status Distribution Pie Chart
          </option>
          <option value="7">Agent Dictations Status Month Wise Trend</option>
          <option value="8">
            Agent Wise Dictations Completion Progress Gauge
          </option>
        </select>
        <button onClick={sendRequest} className="btn btn-outline-primary">
          Display Graphs
        </button>
      </div>
      <div className="graphs">
        <div className="col-lg-6 graph">
          {/* Use Plot component to render first plot */}
          {pdone.data && pdone.layout && (
            <Plot
              data={pdone.data}
              layout={pdone.layout}
              style={{ width: "100%", height: "100%" }}
            />
          )}
        </div>
        <div className="col-lg-6 graph">
          {/* Use Plot component to render second plot */}
          {pdtwo.data && pdtwo.layout && (
            <Plot
              data={pdtwo.data}
              layout={pdtwo.layout}
              style={{ width: "100%", height: "100%" }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
